export default __webpack_public_path__ + "static/media/gallery-h-3.14d42b29.png";